import { CombinedError } from 'urql';

export const isConstraintError = (error: CombinedError | undefined): boolean => {
  return error ? error.message === '[GraphQL] Constraint validation failed' : false;
};
